import React from "react";
import { Box, IconButton, Typography, Stack, Tooltip } from "@mui/material";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import { TimeLeft } from "components/DateTime/TimeLeft";
import { TimeSince } from "components/DateTime/TimeSince";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import DoneIcon from "@mui/icons-material/Done";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { LabelChip } from "components/Chip/LabelChip";
import TaskPreviewModal from "components/Task/TaskPreviewModal";

export const TaskInfoCompact = ({
  heading,
  taskName,
  docDetails,
  description,
  comment,
  assignedBy,
  assignedTo,
  assignedOn,
  acceptanceOn,
  deadline,
  doneOn,
  doneStatus,
  acceptanceStatus,
  actionDropDownForAssignedToMe,
  handleClick,
  fullRowData,
  taskId,
  acknowledgeStatus,
  acknowledgeOn,
  isARequest,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        py: 2.2,
        width: "100%",
      }}
    >
      {/* Dropdown icon (top right) */}
      {actionDropDownForAssignedToMe?.length > 0 && (
        <Tooltip title="Update Status">
          <IconButton
            id="task-action-button"
            onClick={(e) => {
              handleClick(e, taskId, fullRowData);
            }}
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <ArrowDropDownCircleIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      <TaskPreviewModal
        task={{
          title: heading,
          docDetails: docDetails,
          detail: taskName,
          description: description,
          taskByName: assignedBy,
          taskToName: assignedTo,
          taskToOn: assignedOn,
          acceptanceStatus: acceptanceStatus,
          acceptanceComment: comment,
          acceptanceOn: acceptanceOn,
          deadline: deadline,
          doneStatus: doneStatus,
          doneOn: doneOn,
          acknowledgeStatus: acknowledgeStatus,
          acknowledgeOn: acknowledgeOn,
        }}
      >
        {/* Heading + docCode */}
        <Typography
          fontWeight={600}
          fontSize={13.5}
          gutterBottom
          sx={{ lineHeight: 0.5 }}
        >
          {heading}
          {docDetails && (
            <Box
              component="span"
              sx={{ color: "text.secondary", fontWeight: 400 }}
            >
              {" – " + docDetails}
            </Box>
          )}
        </Typography>
        {/* Task name */}
        <Typography
          fontSize={13}
          fontWeight={500}
          sx={{
            mb: 1.5,
            lineHeight: 1,
          }}
        >
          {taskName}
        </Typography>

        {/* Meta Info */}
        <Stack direction="row" flexWrap="wrap" alignItems="center">
          {assignedBy && (
            <LabelChip
              label="By"
              value={assignedBy}
              icon={<PersonIcon sx={{ fontSize: 16 }} />}
            />
          )}
          {assignedTo && (
            <LabelChip
              label="To"
              value={assignedTo || "None"}
              icon={<PersonIcon sx={{ fontSize: 16 }} />}
            />
          )}
          <LabelChip
            label="Assigned"
            value={
              !isARequest && (
                <TimeSince
                  startDate={assignedOn}
                  variant="data"
                  fontSize={11}
                />
              )
            }
            icon={<AccessTimeIcon sx={{ fontSize: 16 }} />}
            backgroundColor={isARequest ? "#c94d2a" : "default"}
          />
          {acceptanceStatus === "ACCEPTED" && acceptanceOn && (
            <LabelChip
              label="Accepted"
              value={
                <TimeSince
                  startDate={acceptanceOn}
                  variant="data"
                  fontSize={11}
                />
              }
              icon={<DoneIcon sx={{ fontSize: 16 }} />}
            />
          )}
          <LabelChip
            label="Deadline"
            value={
              <TimeLeft targetDate={deadline} variant="data" fontSize={11} />
            }
            icon={<EventAvailableIcon sx={{ fontSize: 16 }} />}
          />
          {doneOn && (
            <LabelChip
              label="Done"
              value={
                <TimeSince startDate={doneOn} variant="data" fontSize={11} />
              }
              icon={<DoneIcon sx={{ fontSize: 16 }} />}
            />
          )}
        </Stack>

        {/* Remarks / Comments */}
        {comment && (
          <Typography
            fontSize={12}
            mt={0}
            sx={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.6,
              borderLeft: "2px solid #e0e0e0",
              pl: 1.2,
              transition: "color 0.3s ease",
            }}
          >
            {comment}
          </Typography>
        )}
      </TaskPreviewModal>
    </Box>
  );
};
